import { Module } from 'vuex';
import { RootState } from '@/store/state';
import state, { FamilyState } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const family: Module<FamilyState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

export default family;
